import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { EVENTS } from "@/utils";
import AppDropdown from "@/components/AppDropdown";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import SellerFilter from "@/components/new-filters/SellerFilter.vue";
import MarketplaceFilter from "@/components/new-filters/MarketplaceFilter.vue";
import ProductFilter from "@/components/new-filters/ProductFilter.vue";
import SegmentFilter from "@/components/new-filters/SegmentFilter.vue";
import NavigationTabs from "@/components/NavigationTabs";
import EmptySegments from "@/components/EmptySegments.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
export default {
  name: "PricingAndMarginTopSection",
  components: {
    AppDropdown,
    AppButton,
    AppIcon,
    SellerFilter,
    MarketplaceFilter,
    ProductFilter,
    SegmentFilter,
    NavigationTabs,
    EmptySegments
  },
  mixins: [LiteTableMixin],
  computed: {
    ...mapState({
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      sellers_filter: state => state.pricing_and_margin.sellers_filter,
      marketplaces_filter: state => state.pricing_and_margin.marketplaces_filter,
      products_filter: state => state.pricing_and_margin.products_filter,
      segments_filter: state => state.pricing_and_margin.segments_filter,
      currentTab: state => state.pricing_and_margin.currentTabValue,
      tabs: state => state.pricing_and_margin.tabs
    }),
    ...mapGetters(["pricingAndMarginGetTab"]),
    tab: {
      async set(index) {
        const selectedTab = this.tabs[index];
        if (!selectedTab) return;
        await this.$store.dispatch("pricingAndMarginSetTab", selectedTab.value);
        if (selectedTab.url) {
          this.$router.push(selectedTab.url);
        }
      },
      get() {
        const value = this.pricingAndMarginGetTab();
        const index = this.tabs.findIndex(tab => tab.value === value);
        return index >= 0 ? index : 0;
      }
    },
    computedTabs() {
      return this.tabs;
    }
  },
  data() {
    return {
      sellers: [],
      loading: true
    };
  },
  async mounted() {
    //console.log("page mounted");
  },
  async created() {
    //console.log("page created"); 
  },
  methods: {
    ...mapMutations(["pricingMarginProductsKeyWordListSet"]),
    async applySellers() {
      if (this.sellers_filter.isModified) {
        //console.log("seller filter is modified");
        this.sellers_filter.apply();
        this.products_filter.clearAndApply();
        this.segments_filter.clearAndApply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for sellers...  ",
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_SELLERS_SUB_FILTERS, false);
        window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
      }
    },
    async clearSellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.clear();
        this.products_filter.clearAndApply();
        this.segments_filter.clearAndApply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for sellers...  ",
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_SELLERS_SUB_FILTERS, false);
        window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        this.products_filter.clearAndApply();
        this.segments_filter.clearAndApply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for marketplace...  ",
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
      }
    },
    async applyProducts() {
      if (this.products_filter.isModified) {
        this.products_filter.apply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
      }
    },
    async clearProducts() {
      if (this.products_filter.isModified) {
        this.products_filter.clear();
        this.pricingMarginProductsKeyWordListSet([]);
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
      }
    },
    async applySegments() {
      if (this.segments_filter.isModified) {
        this.segments_filter.apply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching product filters for segments...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_PRODUCTS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
      }
    },
    async handleProductsCleared() {
      window.$bus.trigger("showSuccess", {
        message: "⏳Refreshing ...  ",
        visible: true,
        delay: 10
      });
      await window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
    }
  }
};